// External modules
import styled from '@emotion/styled';

// Internal modules
import { FONT_SIZE_SMALL, LABEL_COLOR } from '@/styles';

export const FullNameLabel = styled.label`
  color: ${LABEL_COLOR};
  font-size: ${FONT_SIZE_SMALL};
  margin-top: 9px;
  display: inline-block;
`;
